import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
export default createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0)">
      <g filter="url(#filter0_d)">
        <path
          d="M16.5625 11.94L7.6225 3L6.2125 4.41L8.5925 6.79L3.4425 11.94C2.8525 12.53 2.8525 13.48 3.4425 14.06L8.9425 19.56C9.2325 19.85 9.6225 20 10.0025 20C10.3825 20 10.7725 19.85 11.0625 19.56L16.5625 14.06C17.1525 13.48 17.1525 12.53 16.5625 11.94ZM5.2125 13L10.0025 8.21L14.7925 13H5.2125ZM19.0025 14.5C19.0025 14.5 17.0025 16.67 17.0025 18C17.0025 19.1 17.9025 20 19.0025 20C20.1025 20 21.0025 19.1 21.0025 18C21.0025 16.67 19.0025 14.5 19.0025 14.5Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="1"
        width="24.0025"
        height="23"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </React.Fragment>,
  `FillShadow`
);
